<template>
  <div class="block">
    <el-carousel trigger="click">
      <el-carousel-item v-for="(item, index) in bannerUrl" :key="index">
        <img :src="item.url" alt />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    bannerUrl: Array
  }
};
</script>
<style>
.block,
.el-carousel,
.el-carousel__container,
.el-carousel__item img {
  width: 100%;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #475669;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
